import AppDispatcher from '../core/AppDispatcher.jsx';
import _ from 'lodash';
import { EventEmitter } from 'events';
import {TrusteeLabels, bankAccountConfirmDetailsLabel, ProductIds, AccountTypeCodes as AccountTypes, ActionTypes, YesNoValues, AccountTypeCodes} from '../constants/ApplicationConstants.js';
import SelectCustomerConstants from '../constants/SelectCustomerConstants.js';
import AccountTypeConstants from '../constants/AccountTypeConstants.js';
import YourDetailsConstants from '../constants/YourDetailsConstants';
import OnlineAccessConstants from '../constants/OnlineAccessConstants';
import AdviserFeeConstants from '../constants/AdviserFeeConstants';
import PortfolioRebateConstants from '../constants/PortfolioRebateConstants';
import AutoRebalancingConstants from '../constants/AutoRebalancingConstants';
import RegularInvestmentPlanConstants from '../constants/RegularInvestmentPlanConstants.js';
import FYPConstants from '../constants/FundingYourProductConstants.js';
import SFTConstants from '../constants/SuperFirstTransferConstant.js';
import ISTConstants from '../constants/InSpecieTransferConstants.js';
import IncomeDistributionConstants from '../constants/IncomeDistributionConstants';
import DownloadConstants from '../constants/DownloadConstants';
import Mapper from '../utils/Mapper.js';
import Formatter from '../utils/Formatter.js';
import Products from '../utils/Products.js';
import BeneficiaryDetailsConstant from '../constants/BeneficiaryDetailsConstant.js';
import PensionPaymentConstants from '../constants/PensionPaymentConstants.js';
import {getContent} from '../services/ContentService.js';
import WorkItemHelper from '../utils/WorkItemHelper';
import ApplicationHelper from '../utils/ApplicationHelper.js';
import DownloadFormsHelper from '../utils/DownloadFormsHelper.js';
import IdVerificationHelper from '../utils/IdVerificationHelper.js';
import ConsolidateInvestmentOptionsHelper from '../utils/ConsolidateInvestmentOptionsHelper.js';
import InSpecieTransferHelper from '../utils/InSpecieTransferHelper.js';
import {ActionTypes as AccountTypeActionTypes } from '../constants/AccountTypeConstants';
import {Constants as WorkItemConstants} from '../constants/WorkItemConstants';

const CHANGE_EVENT = 'change';
let _hasSubmitFailed;

let _formModel = {},
    _annuityQuoteUrl,
    _sectionVisibility = {},
    _product = {},
    _titleList = [],
    _countryList = [],
    _tfnExemptionList = [],
    _showMoreMenu = false,
    _accountType = '',
    _accountNumber = '',
    _consolidatedInvestmentOptions = [],
    _investmentOptionsExternalOnly = [],
    _consolidatedAssetAllocations = [],
    _assetAllocationsExternalOnly = [],
    _consolidatedInSpecieOptions = {},
    _showDownloadMenu = false,
    _formsToDownload = [],
    _productId,
    _downloadInProgress = false,
    _selectedForms = [],
    _readyForDownload = false,
    _downloadedForms = '',
    _formDownloaded = true,
    _downloadFormsFailed = false,
    _accountTypeList = [],
    _workItem = null,
    _canSubmitApplication = _.get(window, 'NOA.entitlements.canSubmitApplication', true),
    _isEmulation = _.get(window, 'NOA.userContext.isEmulation', false),
    _isInSpecieScenarioValid = true,
    _isInSpecieScenarioNotificationClosed = true,
    _showOnlineAccessSection = true,
    _sourceOFFundList = [],
    _sourceOFWealthList = [];

function setReviewData(formModel, product, sectionVisibility) {
    _formModel = _.cloneDeep(formModel);
    _product = _.cloneDeep(product);
    _productId = _product.value;
    _accountType = _.cloneDeep(formModel.form.accountType);
    _sectionVisibility = _.cloneDeep(sectionVisibility);
}

function addConfirmDetails(details, label, value, subsection) {
    if (value) {
        details.push({ label: label, value: value, subsection: subsection });
    }
}

function addConfirmationWithId(details, label, value, id, subsection) {
    if (value) {
        details.push({ label: label, value: value, id: id, subsection: subsection });
    }
}

function setApplicationId(id, wipId) {
    _formModel.id = id;
    if (wipId) {
        _formModel.wipId = wipId;    
    }
}

function setAccountNumber(accountNumber){
    _hasSubmitFailed = false;
    _accountNumber = accountNumber;
}

function getFypInternalRollover(model) {
    let fypConfirmData = {
        rollOverName: model.rollOverName,
        accountNumber: FYPConstants.ConfirmSectionLabels.accNo + model.accountNumber,
        amountValue: Formatter.currencyFormat(model.rollOverAmount)
    };

    let amountLabels = (_product.value === ProductIds.INVESTMENT) ? FYPConstants.AmountLabels.INVESTMENT : FYPConstants.AmountLabels.SUPER_PENSION;
    if (model.isPartialRollOver) {
        let transferMessage = (model.otherInvestmentOption)
            ? Formatter.formatString(FYPConstants.ConfirmSectionLabels.otherInvestmentOption,
                { product: model.otherInvestmentOption })
            : FYPConstants.ConfirmSectionLabels.allocatedInvestmentOption;

        _.assign(fypConfirmData, {
            rollOverTypeLabel: amountLabels.partial,
            remainingBalanceLabel: FYPConstants.summaryLabels.remainingBalance,
            remainingBalanceValue: Formatter.currencyFormat(model.remainingBalance),
            transferInsuranceValue: transferMessage
        });
    } else {
        _.assign(fypConfirmData, {
            rollOverTypeLabel: amountLabels.full,
            remainingBalanceValue: FYPConstants.ConfirmSectionLabels.entireBalance
        });

        if (model.entireBalanceQuestion === YesNoValues.YES) {
            _.assign(fypConfirmData, {
                transferInsuranceLabel: FYPConstants.ConfirmSectionLabels.transferInsurance,
                transferInsuranceValue: YesNoValues.YES_LONG
            });
        } else if (model.entireBalanceQuestion === YesNoValues.NO) {
            _.assign(fypConfirmData, {
                transferInsuranceLabel: FYPConstants.ConfirmSectionLabels.transferInsurance,
                transferInsuranceValue: YesNoValues.NO_LONG
            });
        }
    }

    return fypConfirmData;
}

function getFypExternalRollover(model) {
    let fypConfirmData = {
        rollOverName: model.rollOverNamePredictive || model.rollOverName,
        accountNumber: (model.accountNumber) ? FYPConstants.ConfirmSectionLabels.accNo + model.accountNumber : undefined,
        amountValue: Formatter.currencyFormat(model.rollOverAmount)
    };

    let amountLabels = (_product.value === ProductIds.INVESTMENT) ? FYPConstants.AmountLabels.INVESTMENT : FYPConstants.AmountLabels.SUPER_PENSION;
    if (model.isPartialRollOver) {
        _.assign(fypConfirmData, {
            rollOverTypeLabel: amountLabels.partial
        });
    } else {
        _.assign(fypConfirmData, {
            rollOverTypeLabel: amountLabels.full
        });
    }
    return fypConfirmData;
}

function getFypContribution(model) {
    return {
        rollOverName: FYPConstants.FundTypesLabel[model.rollOverType],
        accountNumber: FYPConstants.summaryLabels.via + ' ' + FYPConstants.ContributionTypesLabel[model.paymentMethod].toLowerCase(),
        rollOverTypeLabel: FYPConstants.summaryLabels.totalAmount,
        amountValue: Formatter.currencyFormat(model.rollOverAmount)
    };

}

function getFypPayment(model) {
    return {
        rollOverName: FYPConstants.ContributionTypesLabel[model.paymentMethod],
        rollOverTypeLabel: FYPConstants.summaryLabels.totalAmount,
        amountValue: Formatter.currencyFormat(model.rollOverAmount)
    };

}

function getFypByFilter(filter, objectGetter) {
    var data = _.filter(_formModel.form.fundingYourProduct.fundingSources, filter);
    var item = [];

    _.forEach(data, (model) => {
        item.push(objectGetter(model));
    });

    return item;
}

function getPensionPaymentFrequency(model, constant) {
    if (model.paymentFrequency !== constant.PaymentFrequency.YEARLY) {
        let data = _.find(constant.PaymentFrequencyData, function (o) { return o.id === model.paymentFrequency; });
        return data.name;
    } else {
        let data = _.find(constant.PaymentFrequencyDates, function (o) { return o.id === (model.yearlyFrequencyDate).slice(3, 5); });
        return Formatter.formatString(constant.Labels.PAYMENT_FREQUENCY_YEARLY_LABEL, { code: data.name });
    }
}

function getYesNoLong(value) {
    if (value === YesNoValues.YES) {
        return YesNoValues.YES_LONG;
    }
    else if (value === YesNoValues.NO) {
        return YesNoValues.NO_LONG;
    }
}

function getPersonalInfo(data) {
    let yourDetails = [];
    if (data.gender) {
        addConfirmDetails(yourDetails, YourDetailsConstants.Labels.gender, _.get(_.find(YourDetailsConstants.GenderRadioData, { 'id': data.gender }), 'name', ''));
    }

    if (data.title && data.givenName && data.lastName) {
        addConfirmDetails(yourDetails, YourDetailsConstants.Labels.fullname, getName(undefined, data));
    }

    if (data.dateOfBirth) {
        addConfirmDetails(yourDetails, YourDetailsConstants.Labels.dateOfBirth, data.dateOfBirth);
    }
    return yourDetails;
}

function getAddressInfo(data) {
    let yourDetails = [];
    
    if (data.residentialAddress) {
        if (data.gender) {
            addConfirmDetails(yourDetails, YourDetailsConstants.Labels.residentialAddress, Formatter.formatResidentialAddress(data.residentialAddress, _countryList));
        }
        else {
            let businessAddressLabel = '';

            switch (_accountType) {
                case AccountTypes.COMPANY:
                case AccountTypes.PARTNERSHIP:
                case AccountTypes.TRUST:
                case AccountTypes.SMSF:
                    businessAddressLabel = YourDetailsConstants.Labels.address.company.residence;
                    break;
                default:
                    businessAddressLabel = YourDetailsConstants.Labels.businessAddress;
            }
            addConfirmDetails(yourDetails, businessAddressLabel, Formatter.formatResidentialAddress(data.residentialAddress, _countryList));
        }
    }

    if (data.postalAddress) {
        if (data.postalAddress.isSameAsResidentialAddress === YesNoValues.YES) {
            if (data.gender) {
                addConfirmDetails(yourDetails, YourDetailsConstants.Labels.postalAddress, YourDetailsConstants.Labels.sameResAddress);
            } else {
                let postalAddressValue = '';

                switch (_accountType) {
                    case AccountTypes.COMPANY:
                    case AccountTypes.PARTNERSHIP:
                    case AccountTypes.TRUST:
                    case AccountTypes.SMSF:
                        postalAddressValue = YourDetailsConstants.Labels.sameCompanyAddress;
                        break;
                    default:
                        postalAddressValue = YourDetailsConstants.Labels.sameBusinessAddress;
                }
                addConfirmDetails(yourDetails, YourDetailsConstants.Labels.postalAddress, postalAddressValue);
            }
        }
        else {
            addConfirmDetails(yourDetails, YourDetailsConstants.Labels.postalAddress, Formatter.formatPostalAddress(data.postalAddress, _countryList));
        }
    }
    return yourDetails;
}

function getContactDetails(data) {
    let yourDetails = [];
    if (data.contactDetails) {
        addConfirmDetails(yourDetails, YourDetailsConstants.Labels.mobileNumber, Formatter.formatPhone(data.contactDetails.mobile));
        addConfirmDetails(yourDetails, YourDetailsConstants.Labels.homeNumber, Formatter.formatPhone(data.contactDetails.home));
        addConfirmDetails(yourDetails, YourDetailsConstants.Labels.workNumber, Formatter.formatPhone(data.contactDetails.work));
        addConfirmDetails(yourDetails, YourDetailsConstants.Labels.emailAddress, data.contactDetails.email);
    }
    return yourDetails;
}

function getIndividualTfnInfo(data) {
    const isInvestment = Products.isInvestment(_product.value);
    const isTrusteeInvestor = (_accountType === AccountTypeCodes.TRUST) && (data.gender || data.trusteeType);
    const isCompanyInvestor = (_accountType === AccountTypeCodes.COMPANY);
    const isPartnershipInvestor = (_accountType === AccountTypeCodes.PARTNERSHIP);
    if (!isInvestment || (!isTrusteeInvestor && !isCompanyInvestor && !isPartnershipInvestor)) {
        return getTfnInfo(data);
    }
    return [];
}


function getTfnInfo(data) {
    let yourDetails = [];

    if (data.tfnInfo) {
        if (data.tfnInfo.exemptionReason && data.tfnInfo.exemptionReason > 0) {
            addConfirmDetails(yourDetails, YourDetailsConstants.Labels.tfnInfo.exemptionReason, findTfnExemption(data.tfnInfo.exemptionReason, _tfnExemptionList));
        }
        else if (data.tfnInfo.tfnNumber) {
            const tfnNumber = data.tfnInfo.tfnNumber === YourDetailsConstants.Labels.tfnInfo.TFN_PROVIDED
                ? YourDetailsConstants.Labels.tfnInfo.TFN_PROVIDED
                : Formatter.mask(data.tfnInfo.tfnNumber);

            switch (data.tfnInfo.tfnConsentFlag) {
                case YesNoValues.YES:
                    addConfirmationWithId(yourDetails, YourDetailsConstants.Labels.tfnInfo.isConsentReceived, YesNoValues.YES_LONG);
                    addConfirmationWithId(yourDetails, YourDetailsConstants.Labels.tfnInfo.tfnNumber, tfnNumber, data.tfnInfo.tfnPlaceHolder);
                    break;
                case YesNoValues.NO:
                    addConfirmationWithId(yourDetails, YourDetailsConstants.Labels.tfnInfo.isConsentReceived, YesNoValues.NO_LONG);
                    if (data.tfnInfo.tfnWithConsent) {
                        addConfirmationWithId(yourDetails, YourDetailsConstants.Labels.tfnInfo.tfnNumber, Formatter.mask(data.tfnInfo.tfnWithConsent), data.tfnInfo.tfnPlaceHolder);
                    } else {
                        addConfirmDetails(yourDetails, YourDetailsConstants.Labels.tfnInfo.tfnNumber, YourDetailsConstants.Labels.tfnInfo.NO_TFN_SUPPLIED);
                    }
                    break;
                default:
                    addConfirmationWithId(yourDetails, YourDetailsConstants.Labels.tfnInfo.tfnNumber, tfnNumber, data.tfnInfo.tfnPlaceHolder);
                    break;
            }
            }
        else {
            addConfirmDetails(yourDetails, YourDetailsConstants.Labels.tfnInfo.tfnNumber, YourDetailsConstants.Labels.tfnInfo.NO_TFN_SUPPLIED);
        }
    }
    
    return yourDetails;
}

function getResidenceInfo(data) {
    let yourDetails = [];
    if (data.countryOfResidence) {
        if (data.isAustralianResident) {
            addConfirmDetails(yourDetails, YourDetailsConstants.Labels.isAustralianResident, getYesNoLong(data.isAustralianResident));
            if (data.isAustralianResident === YesNoValues.NO) {
                addConfirmDetails(yourDetails, YourDetailsConstants.Labels.countryOfResidence, Formatter.findCountry(data.countryOfResidence.country, _countryList));
            }
        }
        else if (data.countryOfResidence.country) {
            addConfirmDetails(yourDetails, YourDetailsConstants.Labels.countryOfResidence, Formatter.findCountry(data.countryOfResidence.country, _countryList));
        }
    }
    return yourDetails;
}

function getTaxResidenceInfo(data) {
    let yourDetails = [], label = YourDetailsConstants.Labels.otherCountryTaxResidence;

    if (_accountType === AccountTypeCodes.INDIVIDUAL || _accountType === AccountTypeCodes.JOINT || _accountType === AccountTypeCodes.SOLE_TRADER || _accountType === AccountTypeCodes.TRUST) {
        label = YourDetailsConstants.Labels.otherCountryTaxResidenceInvestment;
    }

    if (data.taxResidence) {
        if (data.taxResidence.isOtherCountryTaxResident === YesNoValues.YES) {
            _.each(data.taxResidence.countries,
                (country, idx) => {
                    var suffix = '';
                    if (data.taxResidence.countries.length > 1) {
                        suffix = ' #' + (idx + 1);
                    }

                    addConfirmDetails(yourDetails, label + suffix, Formatter.findCountry(country.country, _countryList));
                    
                    if (country.tinExemptionReason) {
                        var reason = _.find(YourDetailsConstants.TinExemtionReasonData, 
                            function(exemption) { return exemption.value === country.tinExemptionReason });
                        addConfirmDetails(yourDetails, YourDetailsConstants.Labels.tin.tinExemptionReason + suffix, reason.label);
                    } else {
                        addConfirmDetails(yourDetails, YourDetailsConstants.Labels.tin.label + suffix, country.tin);
                    }
                });
        }
        else if (data.taxResidence.isOtherCountryTaxResident === YesNoValues.NO) {
            addConfirmDetails(yourDetails, label, YourDetailsConstants.Values.COUNTRY_AUSTRALIA_LONG);
        }else if (Products.isPension(_product.value)) {
            addConfirmDetails(yourDetails, YourDetailsConstants.Labels.otherCountryTaxResidence,
                Formatter.findCountry(data.taxResidence.countries[0].country, _countryList));
        }
    }
    return yourDetails;
}

function getCitizenshipInfo(data) {
    let yourDetails = [];

    let toHide = (!Products.isInvestment(_product.value) && !Products.isAnnuity(_product.value)) ||
        _accountType === AccountTypeCodes.COMPANY ||
        _accountType === AccountTypeCodes.PARTNERSHIP ||
        (_accountType === AccountTypeCodes.TRUST && data.trusteeType === YourDetailsConstants.TrusteeType.CORPORATE)||
        (_accountType === AccountTypeCodes.SMSF && data.trusteeType === YourDetailsConstants.TrusteeType.CORPORATE);

    if (!toHide && data.citizenship && data.citizenship.isCitizenOfOtherCountry === YesNoValues.YES) {
        if (data.citizenship.isCitizenOfOtherCountry === YesNoValues.YES) {
            addConfirmDetails(yourDetails, YourDetailsConstants.Labels.citizenship1, Formatter.findCountry(data.citizenship.citizenship1, _countryList));
            if (data.citizenship.citizenship2) {
                addConfirmDetails(yourDetails, YourDetailsConstants.Labels.citizenship2, Formatter.findCountry(data.citizenship.citizenship2, _countryList));
            }
        }
        else if (data.citizenship.isCitizenOfOtherCountry === YesNoValues.NO) {
            addConfirmDetails(yourDetails, YourDetailsConstants.Labels.citizenship1, YourDetailsConstants.Values.COUNTRY_AUSTRALIA_LONG);
        }
    }
    return yourDetails;
}

function getOccupationInfo(data) {
    let yourDetails = [];
    if (data.occupation) {
        addConfirmDetails(yourDetails, YourDetailsConstants.Labels.occupation, data.occupation.occupation);
    }
    return yourDetails;
}

function findTfnExemption(value, tfnExemptionList) {
    return _.trim(_.get(_.find(tfnExemptionList,
        function (o) { return _.trim(o.value) === _.trim(value); }),
        'label',
        ''));
}

function getBusinessInfo(data) {
    let yourDetails = [];

    if (data.businessName) {
        addConfirmDetails(yourDetails, YourDetailsConstants.Labels.businessName[_accountType], data.businessName);
    }

    if (data.primaryBusinessActivity) {
        addConfirmDetails(yourDetails, YourDetailsConstants.Labels.primaryBusinessActivity[_accountType], data.primaryBusinessActivity);
    }

    if (data.isCharity) {
        addConfirmDetails(yourDetails, YourDetailsConstants.Labels.isCharityInvestment, getYesNoLong(data.isCharity));
    }

    if (data.isPrimaryBusinessInvesting) {
        const isPrimaryBusinessInvesting = data.isPrimaryBusinessInvesting === YesNoValues.YES ? YesNoValues.YES_LONG : YesNoValues.NO_LONG;

        addConfirmDetails(yourDetails, YourDetailsConstants.Labels.primaryBusinessActivityInvesting[_accountType], isPrimaryBusinessInvesting);
    }

    if (data.countryEstablished && data.countryEstablished.country) {
        addConfirmDetails(yourDetails, YourDetailsConstants.Labels.countryEstablished, Formatter.findCountry(data.countryEstablished.country, _countryList));
    }

    if (data.abn !== null && !(data.trusteeId) && !Products.isAnnuity(_productId)) {
        addConfirmDetails(yourDetails, YourDetailsConstants.Labels.abnInvestment, data.abn);
    }

    return yourDetails;
}

function getAbnInfo(data) {
    let yourDetails = [];

    if (data.abn && !(Products.isInvestment(_product.value))) {
        addConfirmDetails(yourDetails, YourDetailsConstants.Labels.abn, data.abn);
    }
    return yourDetails;
}

function getYourDetails(data) {
    let yourDetails = [];
    yourDetails = yourDetails.concat(getTrusteeInfo(data),
        getCompanyInfo(data),
        getPersonalInfo(data),
        getAddressInfo(data),
        getContactDetails(data),
        getIndividualTfnInfo(data),
        getResidenceInfo(data),
        getAustralianTaxResident(data),
        getTaxResidenceInfo(data),
        getCitizenshipInfo(data),
        getBusinessDetailsInfo(data),
        getOccupationInfo(data),
        getKYCInfo(data),
        getApplicationLinked(),
        getPowerOfAttorney(data),
        getAccountDesignation(data),
        getSourceOfFundInfo(data),
        getSourceOfWealthInfo(data)
    );

    return yourDetails;
}

function getCopyTextMessage() {
    let yourDetails = [];
    if (window.NOA.userContext.isInvestor && window.NOA.userContext.isExisting) {
        yourDetails.push({ message: YourDetailsConstants.Labels.fniCopyText });
    }
    return yourDetails;
}

function getApplicationLinked() {
    let yourDetails = [];

    if (window.NOA.userContext.isInvestor) {
        let investorTypeOption = _.find(SelectCustomerConstants.InvestorTypeOptions, { isExisting: window.NOA.userContext.isExisting });
        addConfirmDetails(yourDetails, SelectCustomerConstants.ApplicationLinkLabel, investorTypeOption.displayLabel);
    }else {
        let appLink = ApplicationHelper.findApplicationLinkType(_formModel.applicationLinkType);
        if (appLink) {
            addConfirmDetails(yourDetails, SelectCustomerConstants.ApplicationLinkLabel, appLink.displayLabel);
        }
    }

    return yourDetails;
}

function getPowerOfAttorney(data) {
    let yourDetails = [];

    if (data.isPowerOfAttorney) {
        addConfirmDetails(yourDetails, YourDetailsConstants.Labels.isPowerOfAttorney.label, YourDetailsConstants.Labels.isPowerOfAttorney.displayLabel);
    }

    return yourDetails;

}

function getAustralianTaxResident(data){
    let yourDetails = [];
    
    if (_accountType === AccountTypeCodes.COMPANY ||  _accountType === AccountTypeCodes.PARTNERSHIP) {        
        return yourDetails;
    }

    if (data.isAustralianTaxResident && Products.isInvestment(_product.value)) {
        const australianTaxResident = data.isAustralianTaxResident === YesNoValues.YES ? YesNoValues.YES_LONG : YesNoValues.NO_LONG;
        addConfirmDetails(yourDetails, YourDetailsConstants.Labels.isAustralianTaxResident.label, australianTaxResident);        
    }
    return yourDetails;
}

function getAccountDesignation(data) {
    let yourDetails = [];

    if (!data.accountDesignation) {
        return yourDetails;
    }

    if (Products.isInvestment(_product.value) || Products.isAnnuity(_product.value)) {
        const accountDesignationProvided = data.accountDesignation.isAccountDesignation === YesNoValues.YES &&
            data.accountDesignation.accountDesignationName;
        const accountDesingationNotProvided = data.accountDesignation.isAccountDesignation === YesNoValues.NO || 
            (data.accountDesignation.isAccountDesignation === YesNoValues.YES && !data.accountDesignation.accountDesignationName)

        if (accountDesignationProvided) {
            addConfirmDetails(yourDetails, YourDetailsConstants.Labels.accountDesignation.label, data.accountDesignation.accountDesignationName);
        } else if (accountDesingationNotProvided){
            addConfirmDetails(yourDetails, YourDetailsConstants.Labels.accountDesignation.label, YourDetailsConstants.Labels.accountDesignation.NOT_PROVIDED);
        }
    }
    return yourDetails;
}

function getBusinessDetailsInfo(data) {
    let yourDetails = [];

    if (data.businessName && data.businessName !== '' && _accountType === AccountTypeCodes.SOLE_TRADER) {
        addConfirmDetails(yourDetails, YourDetailsConstants.Labels.business.name, data.businessName);
    }

    if (data.businessAddress && data.businessAddress.address !== '' && _accountType === AccountTypeCodes.SOLE_TRADER) {
        addConfirmDetails(yourDetails, YourDetailsConstants.Labels.address.soleTrader.residence, data.businessAddress.address);
    }

    if (_accountType === AccountTypeCodes.SOLE_TRADER) {
        addConfirmDetails(yourDetails, YourDetailsConstants.Labels.business.abn, data.abn ? data.abn : YourDetailsConstants.Labels.business.ABN_NOT_PROVIDED);
    }

    return yourDetails;
}

function getTrusteeInfo(data) {
    let yourDetails = [];

    if (data.trusteeType && (_accountType === AccountTypeCodes.SMSF || _accountType === AccountTypeCodes.TRUST)) {
        const trusteeTypeValue = TrusteeLabels[(data.trusteeType)];

        addConfirmDetails(yourDetails, YourDetailsConstants.Labels.trustee.trusteeType, trusteeTypeValue);
    }

    if (data.corporateTrustee && (_accountType === AccountTypeCodes.SMSF || _accountType === AccountTypeCodes.TRUST)) {
        addConfirmDetails(yourDetails, YourDetailsConstants.Labels.trustee.corporateTrustee, data.corporateTrustee);
    }

    if (data.abn && (_accountType === AccountTypeCodes.SMSF || _accountType === AccountTypeCodes.TRUST) && (data.trusteeType === YourDetailsConstants.TrusteeType.CORPORATE)) {
        const label = YourDetailsConstants.Labels.abnInvestment;

        addConfirmDetails(yourDetails, label, data.abn);
    }

    if (data.businessAddress && (_accountType === AccountTypeCodes.SMSF || _accountType === AccountTypeCodes.TRUST)) {
        addConfirmDetails(yourDetails, YourDetailsConstants.Labels.companyAddress, data.businessAddress.address);

        let isSameAsAddress = false;
        if (data.businessPostalAddress) {
            if (data.businessPostalAddress.isSameAsResidentialAddress) {
                if(data.businessPostalAddress.isSameAsResidentialAddress === YesNoValues.YES) {
                    isSameAsAddress = true;
                }
            }
            else if(data.businessPostalAddress.isSameAsBusinessAddress) {
                if(data.businessPostalAddress.isSameAsBusinessAddress === YesNoValues.YES) {
                    isSameAsAddress = true;
                }
            }

            if(isSameAsAddress) {
                addConfirmDetails(yourDetails, YourDetailsConstants.Labels.postalAddress, YourDetailsConstants.Labels.sameCompanyAddress);
            }
            else {
                addConfirmDetails(yourDetails, YourDetailsConstants.Labels.postalAddress, data.businessPostalAddress.address);
            }
        }
    }

    return yourDetails;
}

function getCompanyInfo(data) {
    let yourDetails = [];

    if (Products.isInvestment(_product.value) && (_accountType === AccountTypeCodes.SMSF || _accountType === AccountTypeCodes.TRUST || _accountType === AccountTypeCodes.PARTNERSHIP || _accountType === AccountTypeCodes.COMPANY)) {
        if (data.businessName) {
            addConfirmDetails(yourDetails, YourDetailsConstants.Labels.businessName.P, data.businessName);
        }
        if (data.primaryBusinessActivity) {
            addConfirmDetails(yourDetails, YourDetailsConstants.Labels.primaryBusinessActivity[_accountType], data.primaryBusinessActivity);
        }
        if (data.isCharity) {
            const isCharity = data.isCharity === YesNoValues.YES ? YesNoValues.YES_LONG : YesNoValues.NO_LONG;

            addConfirmDetails(yourDetails, YourDetailsConstants.Labels.isCharityInvestment, isCharity);
        }
        if (data.isPrimaryBusinessInvesting) {
            const primaryBusinessActivity = data.isPrimaryBusinessInvesting === YesNoValues.YES ? YesNoValues.YES_LONG : YesNoValues.NO_LONG;

            addConfirmDetails(yourDetails, YourDetailsConstants.Labels.primaryBusinessActivityInvesting[_accountType], primaryBusinessActivity);
        }
        if (data.countryEstablished && data.countryEstablished.country) {
            const country = Formatter.findCountry(data.countryEstablished.country, _countryList);

            addConfirmDetails(yourDetails, YourDetailsConstants.Labels.countryEstablished, country);
        }
        if (data.abn !== null && !(_.isNumber(data.trusteeId))) {
            addConfirmDetails(yourDetails, YourDetailsConstants.Labels.abnInvestment, data.abn);
        }
        if (data.tfnInfo && !(data.gender || data.trusteeType)) {
            if (data.tfnInfo.tfnNumber) {
                addConfirmDetails(yourDetails, YourDetailsConstants.Labels.tfnInfo.tfnNumber, Formatter.mask(data.tfnInfo.tfnNumber));
            }
            else if (data.tfnInfo.exemptionReason) {
                addConfirmDetails(yourDetails, YourDetailsConstants.Labels.tfnInfo.exemptionReason, findTfnExemption(data.tfnInfo.exemptionReason, _tfnExemptionList));
            }
            else {
                addConfirmDetails(yourDetails, YourDetailsConstants.Labels.tfnInfo.tfnNumber, YourDetailsConstants.Labels.tfnInfo.NO_TFN_SUPPLIED);
            }
        }
    }

    return yourDetails;
}

function getKYCInfo(data) {
    let yourDetails = [];

    if (data.kycFlag === true) {
        addConfirmDetails(yourDetails, YourDetailsConstants.Labels.kyc.label, YourDetailsConstants.Labels.kyc.KYC_PROVIDED);
    } else {
        addConfirmDetails(yourDetails, YourDetailsConstants.Labels.kyc.label, YourDetailsConstants.Labels.kyc.KYC_INCOMPLETE);
    }

    return yourDetails;
}

function getBusinessDetails(data) {
    let yourDetails = [];

    yourDetails = yourDetails.concat(getBusinessInfo(data),
        getTfnInfo(data),
        getAbnInfo(data),
        getAddressInfo(data),
        getContactDetails(data),
        getKYCInfo(data),
        getApplicationLinked(),
        getAccountDesignation(data));

    return yourDetails;
}

function getYourDetailsRecord(index) {
    let yourDetails;

    switch (_accountType) {
        case AccountTypes.PARTNERSHIP:
            if (index > 0) {
                yourDetails = _formModel.form.yourDetails.investorList[index - 1];
            }
            else {
                yourDetails = _formModel.form.yourDetails;
            }
            break;
        case AccountTypes.JOINT:
            yourDetails = _formModel.form.yourDetails.investorList[index];
            break;
        case AccountTypes.COMPANY:
            if (index > 0) {
                yourDetails = _formModel.form.yourDetails.investorList[index - 1];
            }
            else {
                yourDetails = _formModel.form.yourDetails;
            }
            break;
        case AccountTypes.TRUST:
        case AccountTypes.SMSF:
            if (index > 0) {
                yourDetails = _formModel.form.yourDetails.trusteeList[index - 1];
            }
            else {
                yourDetails = _formModel.form.yourDetails;
            }
            break;
        default:
            yourDetails = _formModel.form.yourDetails;
            break;
    }

    return yourDetails;
}

function getName(index, data) {
    const yourDetails = data || getYourDetailsRecord(index);

    if (yourDetails && yourDetails.gender && yourDetails.title && yourDetails.givenName && yourDetails.lastName) {
        let title = Mapper.getGenderTitle(yourDetails.gender, yourDetails.title, _titleList, YourDetailsConstants.Values.GENDER_MALE, YourDetailsConstants.Values.GENDER_FEMALE);

        return Formatter.formatFullname(title, yourDetails.givenName, yourDetails.lastName);
    }
    else if((_accountType === AccountTypeCodes.SMSF || _accountType === AccountTypeCodes.TRUST) && yourDetails.corporateTrustee) {
        return yourDetails.corporateTrustee;
    }
    else {
        return '';
    }
}

function getCorporateName(index, data) {
    const yourDetails = data || getYourDetailsRecord(index);
    if (yourDetails && yourDetails.businessName) {
        return yourDetails.businessName;
    } else {
        return '';
    }
}

function updateFormModelWorkItem(workItem) {
    _formModel.form.workItem = WorkItemHelper.getUpdatedFormModel(_formModel, workItem);
}

function updateFormModelIdVerification(idVerificationModel) {
    _formModel.form.idVerification = _.cloneDeep(idVerificationModel);
    //Setting kycFlag to false to show KYC as Incomplete
    _formModel.form.yourDetails.kycFlag = false;
}

function updateYourDetailsForSave() {
    if (_formModel.form) {
        _formModel.form.yourDetails =
            IdVerificationHelper.formatVerificationDocuments(_formModel.productId, _formModel.form.accountType, _formModel.form.yourDetails, _formModel.form.idVerification);
    }
}

function updateAdviserAuthorityModel(model,value) {    
    if (_formModel.form) {
        _formModel.form.adviserAuthority[model]=value;
    }    
}

function agreeIdVerificationForm() {
    //Setting kycFlag to true to show KYC as Provided
    let {accountType, yourDetails, idVerification} = _formModel.form;
    yourDetails.kycFlag = true;
    yourDetails.investorList && yourDetails.investorList.map(investor => investor.kycFlag = true);
    yourDetails =
        IdVerificationHelper.formatVerificationDocuments(_formModel.productId, accountType, yourDetails, idVerification, true);
}

function calculateInvAllocations() {
    const result = ConsolidateInvestmentOptionsHelper.calculateInvAllocations(
        _formModel.form.fundingYourProduct, 
        _formModel.form.investmentAllocation, 
        _formModel.form.inSpecieTransfer, 
        _product.value);

    const isInSpecie = _.get(_formModel, 'form.inSpecieTransfer.setUp', null) === YesNoValues.YES && Products.isPension(_product.value);
    const isInSpecieScenarioValid = !InSpecieTransferHelper.getIsManualSignApplicationNeeded(isInSpecie, result.consolidatedInSpecieOptions);

    _consolidatedInSpecieOptions = result.consolidatedInSpecieOptions;
    _consolidatedInvestmentOptions = result.consolidatedInvestmentOptions;
    _investmentOptionsExternalOnly = result.investmentOptionsExternalOnly;
    _consolidatedAssetAllocations = result.consolidatedAssetAllocations;
    _assetAllocationsExternalOnly = result.assetAllocationsExternalOnly;
    _isInSpecieScenarioValid = isInSpecieScenarioValid;
    _isInSpecieScenarioNotificationClosed = isInSpecieScenarioValid; 
}

function toggleDownloadMenu(showDownloadMenu) {
    _showDownloadMenu = showDownloadMenu;
    if (showDownloadMenu) {
        _formsToDownload = DownloadFormsHelper.getFormsList(_productId, _accountType);
    } else {
        _formsToDownload = [];
    }
    _selectedForms = [];
    _downloadInProgress = false;
    _downloadFormsFailed = false;
}

function updateFormsToDownload(index, checked) {
    if (_formsToDownload[index]) {
        _formsToDownload[index].checked = checked;
    }
}

function getSelectedForms() {
    if (_formsToDownload && _formsToDownload.length > 0) {
        _selectedForms = DownloadFormsHelper.getSelectedForms(_formsToDownload);
        _downloadInProgress = true;
    }
}

function receiveDownloadedApplicationForm(data) {
    if (data.attachments && data.attachments.length > 0) {
        let url = DownloadConstants.Base64String;
        _downloadedForms = url.replace('{contentType}', data.attachments[0].contentType).replace('{base64}', data.attachments[0].body);
    }
    _downloadFormsFailed = false;
    _formDownloaded = false;
    _downloadInProgress = false;
    _showDownloadMenu = false;
    _formsToDownload = [];
    _selectedForms = [];
}

function hasAllocationsCheck(allocations, investmentOptions) {
    const investmentOptionIdsWithAssetAllocation = _.groupBy(allocations,
        (allocation) => {
            return allocation.investmentOptionId;
        });

    let hasAllocations = true;
    _.each(investmentOptions, invOption => {
        if (!_.get(investmentOptionIdsWithAssetAllocation, invOption.id, null)) {
            hasAllocations = false;
        }
    });
    return hasAllocations;
}

function setWorkItem() {
    let backFile = [];
    const isPension = Products.isPension(_product.value),
    isInvestment = Products.isInvestment(_product.value),
    isSuper = Products.isSuper(_product.value),
    content = getContent().workItemInstructions,
    data = _formModel.form;

    // BackFile - Adviser & Customer Information
    let adviserInfo = '<div class="container">', customerInfo = '<div class="container">';
    adviserInfo += WorkItemHelper.generateRow('Adviser name', '__BACKFILE__ADVISER__ADVISERNAME');
    adviserInfo += WorkItemHelper.generateRow('Dealer ID', '__BACKFILE__ADVISER__DEALERID');
    adviserInfo += WorkItemHelper.generateRow('Adviser ID', '__BACKFILE__ADVISER__ADVISERID');
    adviserInfo += WorkItemHelper.generateRow('Phone number', '__BACKFILE__ADVISER__PHONENUMBER');
    adviserInfo += '</div>';
    customerInfo += WorkItemHelper.generateRow('Account number', '__BACKFILE__CUSTOMER__ACCOUNTNUMBER');
    customerInfo += WorkItemHelper.generateRow('TRN', '__BACKFILE__CUSTOMER__TRN');
    customerInfo += WorkItemHelper.generateRow('OIN', WorkItemConstants.BackfileCustomerOin);
    customerInfo += WorkItemHelper.generateRow('PDS DATE', '__BACKFILE__CUSTOMER__PDSDATE');
    customerInfo += '</div>';

    backFile.push({
        id: 'BACKFILE_ADVISER_INFORMATION',
        title: 'Adviser information',
        htmlConstruct: adviserInfo
    });
    backFile.push({
        id: 'BACKFILE_CUSTOMER_INFORMATION',
        title: 'Customer information',
        htmlConstruct: customerInfo
    });

    if(isPension) {
        // BackFile
        if(data.yourDetails.investorList.length > 0) {
            backFile.push({
                id: 'BACKFILE_PENSION_YOUR_DETAILS_INVESTOR_0',
                containers: ['yourDetails__backFile__0'],
                wrap: true,
                replacePlaceHolder: _.get(data, 'yourDetails.tfnInfo.tfnPlaceHolder', null)
            });
            _.each(data.yourDetails.investorList, (investor, idx) => {
                backFile.push({
                    id: 'BACKFILE_PENSION_YOUR_DETAILS_INVESTOR_' + (idx++),
                    containers: ['yourDetails__backFile__' + (idx++)],
                    wrap: true,
                    replacePlaceHolder: _.get(investor, 'tfnInfo.tfnPlaceHolder', null)
                });
            });
        }else if(data.yourDetails.trusteeList.length > 0) {
            backFile.push({
                id: 'BACKFILE_PENSION_YOUR_DETAILS_TRUSTEE_0',
                containers: ['yourDetails__backFile__0'],
                wrap: true,
                replacePlaceHolder: _.get(data, 'yourDetails.tfnInfo.tfnPlaceHolder', null)
            });
            _.each(data.yourDetails.trusteeList, (trustee, idx) => {
                backFile.push({
                    id: 'BACKFILE_PENSION_YOUR_DETAILS_TRUSTEE_' + (idx++),
                    containers: ['yourDetails__backFile__' + (idx++)],
                    wrap: true,
                    replacePlaceHolder: _.get(trustee, 'tfnInfo.tfnPlaceHolder', null)
                });
            });
        }else {
            backFile.push({
                id: 'BACKFILE_PENSION_YOUR_DETAILS',
                containers: ['yourDetails__backFile__0'],
                wrap: true,
                replacePlaceHolder: _.get(data, 'yourDetails.tfnInfo.tfnPlaceHolder', null)
            });
        }

        backFile.push({
            id: 'BACKFILE_PENSION_TYPE',
            containers: ['pensionType']
        });
        backFile.push({
            id: 'BACKFILE_PENSION_FUNDING_YOUR_PRODUCT',
            containers: ['fundingYourProduct']
        });
        backFile.push({
            id: 'BACKFILE_PENSION_INSPECIE_TRANSFER',
            containers: ['inSpecieTransfer']
        });
        backFile.push({
            id: 'BACKFILE_PENSION_SUPER_FIRST',
            containers: ['superFirstTransfer']
        });
        backFile.push({
            id: 'BACKFILE_PENSION_INVESTMENT_ALLOCATION',
            containers: ['investmentAllocation']
        });
        backFile.push({
            id: 'BACKFILE_PENSION_PAYMENT_DETAILS',
            containers: ['pensionPayment']
        });
        backFile.push({
            id: 'BACKFILE_PENSION_BENEFICIARY_DETAILS',
            containers: ['beneficiaryDetails']
        });
        backFile.push({
            id: 'BACKFILE_REGULAR_INVESTMENT_PLAN',
            containers: ['regularInvestmentPlan']
        });
        backFile.push({
            id: 'BACKFILE_PENSION_PORTFOLIO_REBATE',
            containers: ['portfolioRebate']
        });
        backFile.push({
            id: 'BACKFILE_PENSION_AUTO_REBALANCING',
            containers: ['autoRebalancing']
        });
        if(data.adviceFee && data.adviceFee.AdviceFeesList && data.adviceFee.AdviceFeesList.length > 0) {
            backFile.push({
                id: 'BACKFILE_PENSION_ADVISER_FEES',
                containers: ['adviserFee']
            });
        }
        if(data.onlineAccess.length > 0) {
            backFile.push({
                id: 'BACKFILE_PENSION_ONLINE_ACCESS',
                containers: ['onlineAccess']
            });
        }
        if(data.specialRequests && data.specialRequests.isWithSpecialRequests === YesNoValues.YES) {
            backFile.push({
                id: 'BACKFILE_PENSION_SPECIAL_INSTRUCTION',
                containers: ['specialRequests']
            });
        }
    }

    if(isInvestment) {
        // BackFile
        if(_accountType === AccountTypeCodes.JOINT) {
            if(data.yourDetails.investorList.length > 0) {
                _.each(data.yourDetails.investorList, (investor, idx) => {
                    backFile.push({
                        id: 'BACKFILE_INVESTMENT_YOUR_DETAILS_INVESTOR_' + (idx),
                        containers: ['yourDetails__backFile__' + (idx)],
                        wrap: true,
                        replacePlaceHolder: _.get(investor, 'tfnInfo.tfnPlaceHolder', null)
                    });
                });
            }
        }else if(_accountType === AccountTypeCodes.TRUST || _accountType === AccountTypeCodes.SMSF) {
            backFile.push({
                id: 'BACKFILE_INVESTMENT_YOUR_DETAILS_TRUSTEE_0',
                containers: ['yourDetails__backFile__0'],
                wrap: true,
                replacePlaceHolder: _.get(data, 'yourDetails.tfnInfo.tfnPlaceHolder', null)
            });
            if(data.yourDetails.trusteeList.length > 0) {
                _.each(data.yourDetails.trusteeList, (trustee, idx) => {
                    backFile.push({
                        id: 'BACKFILE_INVESTMENT_YOUR_DETAILS_TRUSTEE_' + (idx++),
                        containers: ['yourDetails__backFile__' + (idx++)],
                        wrap: true,
                        replacePlaceHolder: _.get(trustee, 'tfnInfo.tfnPlaceHolder', null)
                    });
                });
            }
        }else {
            backFile.push({
                id: 'BACKFILE_INVESTMENT_YOUR_DETAILS',
                containers: ['yourDetails__backFile__0'],
                wrap: true,
                replacePlaceHolder: _.get(data, 'yourDetails.tfnInfo.tfnPlaceHolder', null)
            });
        }

        backFile.push({
            id: 'BACKFILE_INVESTMENT_FUNDING_YOUR_PRODUCT',
            containers: ['fundingYourProduct']
        });
        backFile.push({
            id: 'BACKFILE_INVESTMENT_INVESTMENT_ALLOCATION',
            containers: ['investmentAllocation']
        });
        backFile.push({
            id: 'BACKFILE_REGULAR_INVESTMENT_PLAN',
            containers: ['regularInvestmentPlan']
        });
        backFile.push({
            id: 'BACKFILE_INVESTMENT_PORTFOLIO_REBATE',
            containers: ['portfolioRebate']
        });
        if(data.incomeDistribution) {
            backFile.push({
                id: 'BACKFILE_INVESTMENT_INCOME_DISTRIBUTION',
                containers: ['incomeDistribution']
            });
        }
        backFile.push({
            id: 'BACKFILE_INVESTMENT_AUTO_REBALANCING',
            containers: ['autoRebalancing']
        });
        if(data.adviceFee && data.adviceFee.AdviceFeesList && data.adviceFee.AdviceFeesList.length > 0) {
            backFile.push({
                id: 'BACKFILE_INVESTMENT_ADVISER_FEE',
                containers: ['adviserFee']
            });
        }
        if(data.onlineAccess.length > 0) {
            backFile.push({
                id: 'BACKFILE_INVESTMENT_ONLINE_ACCESS',
                containers: ['onlineAccess']
            });
        }
    }

    if(isSuper) {
        // BackFile
        if(data.yourDetails.investorList.length > 0) {
            backFile.push({
                id: 'BACKFILE_SUPER_YOUR_DETAILS_INVESTOR_0',
                containers: ['yourDetails__backFile__0'],
                wrap: true,
                replacePlaceHolder: _.get(data, 'yourDetails.tfnInfo.tfnPlaceHolder', null)
            });
            _.each(data.yourDetails.investorList, (investor, idx) => {
                backFile.push({
                    id: 'BACKFILE_SUPER_YOUR_DETAILS_INVESTOR_' + (idx++),
                    containers: ['yourDetails__backFile__' + (idx+1)],
                    wrap: true,
                    replacePlaceHolder: _.get(investor,'tfnInfo.tfnPlaceHolder', null)
                });
            });
        }else if(data.yourDetails.trusteeList.length > 0) {
            backFile.push({
                id: 'BACKFILE_SUPER_YOUR_DETAILS_TRUSTEE_0',
                containers: ['yourDetails__backFile__0'],
                wrap: true,
                replacePlaceHolder: _.get(data, 'yourDetails.tfnInfo.tfnPlaceHolder', null)
            });
            _.each(data.yourDetails.trusteeList, (trustee, idx) => {
                backFile.push({
                    id: 'BACKFILE_SUPER_YOUR_DETAILS_TRUSTEE_' + (idx++),
                    containers: ['yourDetails__backFile__' + (idx+1)],
                    wrap: true,
                    replacePlaceHolder: _.get(trustee, 'tfnInfo.tfnPlaceHolder', null)
                });
            });
        }else {
            backFile.push({
                id: 'BACKFILE_SUPER_YOUR_DETAILS',
                containers: ['yourDetails__backFile__0'],
                wrap: true,
                replacePlaceHolder: _.get(data, 'yourDetails.tfnInfo.tfnPlaceHolder', null)
            });
        }
        backFile.push({
            id: 'BACKFILE_SUPER_FUNDING_YOUR_PRODUCT',
            containers: ['fundingYourProduct']
        });
        backFile.push({
            id: 'BACKFILE_SUPER_INVESTMENT_ALLOCATION',
            containers: ['investmentAllocation']
        });
        backFile.push({
            id: 'BACKFILE_REGULAR_INVESTMENT_PLAN',
            containers: ['regularInvestmentPlan']
        });
        backFile.push({
            id: 'BACKFILE_SUPER_PORTFOLIO_REBATE',
            containers: ['portfolioRebate']
        });
        backFile.push({
            id: 'BACKFILE_SUPER_AUTO_REBALANCING',
            containers: ['autoRebalancing']
        });
        if(data.adviceFee && data.adviceFee.AdviceFeesList && data.adviceFee.AdviceFeesList.length > 0) {
            backFile.push({
                id: 'BACKFILE_SUPER_ADVICE_FEES',
                containers: ['adviserFee']
            });
        }
        if(data.onlineAccess.length > 0) {
            backFile.push({
                id: 'BACKFILE_SUPER_ONLINE_ACCESS',
                containers: ['onlineAccess']
            });
        }
    }

    const _fileNote = WorkItemHelper.extractFilenote(data, _product.value, content);

    const _backFile = WorkItemHelper.generateFileNote('e-Setup application filenote - ' + WorkItemConstants.FilenoteProduct, {
        file: backFile,
        isBackFile: true
    });

    if (_workItem === null) {
        _workItem = {};
    }

    _.assign(_workItem, { fileNote: _fileNote, confirmDetailsBackFile: _backFile});
}

function getSourceOfFundInfo(data) {
    let yourDetails = [];
    if (data.sourceOfFund) {
        addConfirmDetails(yourDetails, YourDetailsConstants.Labels.sourceOfFund, Formatter.findSofSow(data.sourceOfFund, _sourceOFFundList));
        if (data.otherSourceOfFund) {
            addConfirmDetails(yourDetails, YourDetailsConstants.Labels.otherSourceOfFund, data.otherSourceOfFund);
        }
    }
    return yourDetails;
}
function getSourceOfWealthInfo(data) {
    let yourDetails = [];
    if (data.sourceOfWealth) {
        addConfirmDetails(yourDetails, YourDetailsConstants.Labels.sourceOfWealth, Formatter.findSofSow(data.sourceOfWealth, _sourceOFWealthList));
        if (data.otherSourceOfWealth) {
            addConfirmDetails(yourDetails, YourDetailsConstants.Labels.otherSourceOfWealth, data.otherSourceOfWealth);
        }
    }
    return yourDetails;
}

class ConfirmDetailsStoreClass extends EventEmitter {
    constructor() {
        super();
    }

    addChangeListener(cb) {
        this.on(CHANGE_EVENT, cb);
    }

    removeChangeListener(cb) {
        this.removeListener(CHANGE_EVENT, cb);
    }

    emitChange() {
        return this.emit(CHANGE_EVENT);
    }

    getProduct() {
        return _product;
    }

    getSectionVisibility() {
        return _sectionVisibility;
    }

    getYourDetails() {
        let yourDetails = [];
        const data = _formModel.form.yourDetails;
        
        switch (_accountType) {
            case AccountTypes.JOINT:
                _.forEach(data.investorList, (child, index) => {
                    yourDetails.push({ sectionName: 'Investor ' + (index + 1), data: getYourDetails(child) });
                });
                break;
            case AccountTypes.PARTNERSHIP:
                yourDetails.push({ sectionName: 'Partnership', data: getBusinessDetails(data) });
                _.forEach(data.investorList, (child, index) => {
                    yourDetails.push({ sectionName: 'Individual ' + (index + 1), data: getYourDetails(child) });
                });
                break;
            case AccountTypes.COMPANY:
                yourDetails.push({ sectionName: 'Company', data: getBusinessDetails(data) });
                _.forEach(data.investorList, (child, index) => {
                    yourDetails.push({ sectionName: 'Individual ' + (index + 1), data: getYourDetails(child) });
                });
                break;
            case AccountTypes.SMSF:
                yourDetails.push({ sectionName: 'SMSF', data: getBusinessDetails(data) });
                _.forEach(data.trusteeList, (child, index) => {
                    yourDetails.push({ sectionName: 'Trustee ' + (index + 1), data: getYourDetails(child) });
                });
                break;
            case AccountTypes.TRUST:
                yourDetails.push({ sectionName: 'Trust', data: getBusinessDetails(data) });
                _.forEach(data.trusteeList, (child, index) => {
                    yourDetails.push({ sectionName: 'Trustee ' + (index + 1), data: getYourDetails(child) });
                });
                break;
            default:
                let yd = getYourDetails(data);
                yourDetails.push({ sectionName: '', data: yd });
                break;
        }
        
        yourDetails.push({data: getCopyTextMessage()});
        return yourDetails;
    }

    getIncomeDistribution() {
        let incomeDistribution = {},
            data = _formModel.form.incomeDistribution || undefined,
            iDItems = [],
            bankAccountLabel = bankAccountConfirmDetailsLabel;

        if (Products.isInvestment(_product.value) && data) {
            if (data.paymentMethod === IncomeDistributionConstants.bankAccountText) {
                if (data.selectedBankAccount === IncomeDistributionConstants.nominateText) {

                    const accountHolderName = data.accountHolderName && data.accountHolderName.length > 0 ? data.accountHolderName : bankAccountLabel.incomplete;
                    const branchNo =  data.branchNumber && data.branchNumber.length > 0 ? Formatter.formatBranchNumber(data.branchNumber) : bankAccountLabel.incomplete;
                    const accountNumber = data.accountNumber && data.accountNumber.length > 0 ? data.accountNumber : bankAccountLabel.incomplete;

                    addConfirmDetails(iDItems, FYPConstants.sectionLabels.accountHolderName, accountHolderName);
                    addConfirmDetails(iDItems, FYPConstants.sectionLabels.branchNumber, branchNo);
                    addConfirmDetails(iDItems, FYPConstants.sectionLabels.accountNumber, accountNumber);
                } else {
                    const accountDetails = _.filter(_formModel.form.fundingYourProduct.fundingSources, (o) => { return o.paymentMethod === FYPConstants.ContributionValues.DIRECT_D && o.accountNumber === data.selectedBankAccount });
                    let accountHolderName = bankAccountLabel.incomplete;
                    let branchNo = bankAccountLabel.incomplete;
                    let accountNumber = bankAccountLabel.incomplete;
                    if (accountDetails[0]) {
                        accountHolderName = accountDetails[0].accountHolderName && accountDetails[0].accountHolderName.length > 0 ? accountDetails[0].accountHolderName : bankAccountLabel.incomplete;
                        branchNo = accountDetails[0].branchNumber && accountDetails[0].branchNumber.length > 0 ? Formatter.formatBranchNumber(accountDetails[0].branchNumber) : bankAccountLabel.incomplete;
                        accountNumber = accountDetails[0].accountNumber && accountDetails[0].accountNumber.length > 0 ? accountDetails[0].accountNumber : bankAccountLabel.incomplete;
                    }
                    addConfirmDetails(iDItems, FYPConstants.sectionLabels.accountHolderName, accountHolderName);
                    addConfirmDetails(iDItems, FYPConstants.sectionLabels.branchNumber, branchNo);
                    addConfirmDetails(iDItems, FYPConstants.sectionLabels.accountNumber, accountNumber);
                }

            }

            incomeDistribution.paymentMethod = data.paymentMethod;
            incomeDistribution.items = iDItems;

            return incomeDistribution;
        }

        return null;
    }

    getAutoBalancingInfo() {
        const autoBalancingInfo = [],
            data = _formModel.form.autoRebalancing;
        if (data.SetAutoRebalancing) {
            addConfirmDetails(autoBalancingInfo, AutoRebalancingConstants.Labels.SETUP_AUTOREBALANCING, getYesNoLong(data.SetAutoRebalancing));
            if (data.SetAutoRebalancing === YesNoValues.YES) {
                const frequency = (data.Frequency === AutoRebalancingConstants.Values.ANNUALLY)
                    ? AutoRebalancingConstants.Labels.FREQUENCY_ANNUALLY
                    : AutoRebalancingConstants.Labels.FREQUENCY_QUARTERLY;
                addConfirmDetails(autoBalancingInfo, AutoRebalancingConstants.Labels.FREQUENCY, frequency);
            }

        }

        return autoBalancingInfo;
    }

    throwIfInvestedOptionNotFound(investmentOption, investmentAllocationId) {
        if (!investmentOption) {
            throw new Error('Could not find allocated investment option of [' + investmentAllocationId + ']');
        }
    }

    getAdviserFees() {
        const adviserFees = [],
            data = _.sortBy(_formModel.form.adviceFee.AdviceFeesList, 'id'),
            monthly = ' per month',
            percentage = '% per annum';

        if (data.length <= 0) {
            addConfirmDetails(adviserFees, AdviserFeeConstants.Labels.NO_ADVISER_FEES, YesNoValues.NO_LONG);
        }

        _.forEach(data, (inv) => {
            let investmentName, value, investmentOption = '';
            const CPI = inv.IsConsumerPriceIndex === YesNoValues.YES ? AdviserFeeConstants.Labels.CPI : '';

            if (inv.feeType === AdviserFeeConstants.FeeTypes.ASF) {

                if (inv.frequency === AdviserFeeConstants.Frequencies.ONGOING) {
                    investmentName = AdviserFeeConstants.Labels.ASF_ONGOING;

                    if (inv.onGoingType === AdviserFeeConstants.OngoingTypes.BOTH) {
                        value = Formatter.currencyFormat(inv.onGoingMonthlyAmount, true) + monthly + CPI + ' AND ' + inv.ongoingAnnualPercentage + percentage;
                    } else if (inv.onGoingType === AdviserFeeConstants.OngoingTypes.AMT) {
                        value = Formatter.currencyFormat(inv.onGoingMonthlyAmount, true) + monthly + CPI;
                    } else if (inv.onGoingType === AdviserFeeConstants.OngoingTypes.PER) {
                        value = inv.ongoingAnnualPercentage + percentage + CPI;
                    }

                    if (inv.investmentAllocationId !== -1) {
                        investmentOption = _.find(inv.investmentList, (option) => {
                            const idAsNumber = parseInt(option.id);
                            const invIdAsNumber = parseInt(inv.investmentAllocationId);
                            return idAsNumber === invIdAsNumber;
                        });
                        this.throwIfInvestedOptionNotFound(investmentOption, inv.investmentAllocationId);
                        const invOption = investmentOption.name + ' (' + investmentOption.code + ')';
                        addConfirmDetails(adviserFees, investmentName, value);
                        addConfirmDetails(adviserFees, AdviserFeeConstants.Labels.FEE_DEDUCTED_FROM, invOption, true);
                    } else {
                        addConfirmDetails(adviserFees, investmentName, value, true);
                    }
                } else if (inv.frequency === AdviserFeeConstants.Frequencies.ONEOFF) {
                    investmentName = AdviserFeeConstants.Labels.ASF_ONEOFF;
                    let hasSuperFirstTransAmount = _formModel.form.superFirstTransfer.isSuperTransferSetup === YesNoValues.YES && inv.superFirstTransferFacility !== '';
                    if (_product.value === ProductIds.PENSION) {
                        if (hasSuperFirstTransAmount) {
                            let sumOfTransAndPension = Mapper.toCurrency(inv.superFirstTransferFacility) + Mapper.toCurrency(inv.pensionAmount);
                            value = Formatter.currencyFormat(sumOfTransAndPension, true);
                        } else {
                            value = Formatter.currencyFormat(inv.pensionAmount, true);
                        }
                    } else {
                        value = Formatter.currencyFormat(inv.feeAmount, true);
                    }

                    if (inv.adviceFeeDeductionOption === AdviserFeeConstants.DeductionOptions.SELECT_OPTION) {
                        addConfirmDetails(adviserFees, investmentName, value);

                        investmentOption = _.find(inv.investmentList, (option) => {
                            const idAsNumber = parseInt(option.id);
                            const invIdAsNumber = parseInt(inv.investmentAllocationId);
                            return idAsNumber === invIdAsNumber;
                        });
                        this.throwIfInvestedOptionNotFound(investmentOption, inv.investmentAllocationId);
                        const invOption = investmentOption.name + ' (' + investmentOption.code + ')';

                        if (_product.value === ProductIds.PENSION && hasSuperFirstTransAmount) {
                            let weightingWithSuperFirstMessage = '';
                            if (inv.pensionAmount){
                                weightingWithSuperFirstMessage = invOption
                                .concat(' ', Formatter.currencyFormat(inv.pensionAmount, true),
                                    ' AND ', AdviserFeeConstants.Labels.INVESTMENT_WEIGHTING_FROM_SUPERFIRST,
                                    ' ', Formatter.currencyFormat(inv.superFirstTransferFacility, true));
                            }
                            else{
                                weightingWithSuperFirstMessage = AdviserFeeConstants.Labels.INVESTMENT_WEIGHTING_FROM_SUPERFIRST;
                            }

                            addConfirmDetails(adviserFees, AdviserFeeConstants.Labels.FEE_DEDUCTED_FROM, weightingWithSuperFirstMessage, true);
                        } else {
                            addConfirmDetails(adviserFees, AdviserFeeConstants.Labels.FEE_DEDUCTED_FROM, invOption, true);
                        }
                    } else if (inv.adviceFeeDeductionOption === AdviserFeeConstants.DeductionOptions.INVESTMENT_WEIGHTING) {
                        addConfirmDetails(adviserFees, investmentName, value);

                        if (_product.value === ProductIds.PENSION && hasSuperFirstTransAmount) {
                            let weightingWithSuperFirstMessage = '';
                            if (inv.pensionAmount){
                                weightingWithSuperFirstMessage = AdviserFeeConstants.Labels.INVESTMENT_WEIGHTING
                                .concat(' ', Formatter.currencyFormat(inv.pensionAmount, true),
                                    ' AND ', AdviserFeeConstants.Labels.INVESTMENT_WEIGHTING_FROM_SUPERFIRST,
                                    ' ', Formatter.currencyFormat(inv.superFirstTransferFacility, true));
                            }
                            else{
                                weightingWithSuperFirstMessage = AdviserFeeConstants.Labels.INVESTMENT_WEIGHTING_FROM_SUPERFIRST;
                            }

                            addConfirmDetails(adviserFees, AdviserFeeConstants.Labels.INVESTMENT_WEIGHTING_FEE_DEDUCTED, weightingWithSuperFirstMessage, true);
                        } else {
                            addConfirmDetails(adviserFees, AdviserFeeConstants.Labels.INVESTMENT_WEIGHTING_FEE_DEDUCTED, AdviserFeeConstants.Labels.INVESTMENT_WEIGHTING, true);
                        }
                    } else {
                        addConfirmDetails(adviserFees, investmentName, value, true);
                    }
                }

            } else if (inv.feeType === AdviserFeeConstants.FeeTypes.LSF) {
                investmentName = AdviserFeeConstants.Labels.LSF_ONGOING;

                if (inv.onGoingType === AdviserFeeConstants.OngoingTypes.BOTH) {
                    value = Formatter.currencyFormat(inv.onGoingMonthlyAmount, true) + monthly + CPI + ' AND ' + inv.ongoingAnnualPercentage + percentage;
                } else if (inv.onGoingType === AdviserFeeConstants.OngoingTypes.AMT) {
                    value = Formatter.currencyFormat(inv.onGoingMonthlyAmount, true) + monthly + CPI;
                } else if (inv.onGoingType === AdviserFeeConstants.OngoingTypes.PER) {
                    value = inv.ongoingAnnualPercentage + percentage + CPI;
                }

                if (inv.investmentAllocationId !== -1) {
                    investmentOption = _.find(inv.investmentList, (option) => {
                        const idAsNumber = parseInt(option.id);
                        const invIdAsNumber = parseInt(inv.investmentAllocationId);
                        return idAsNumber === invIdAsNumber;
                    });
                    this.throwIfInvestedOptionNotFound(investmentOption, inv.investmentAllocationId);
                    const invOption = investmentOption.name + ' (' + investmentOption.code + ')';
                    addConfirmDetails(adviserFees, investmentName, value);
                    addConfirmDetails(adviserFees, AdviserFeeConstants.Labels.FEE_DEDUCTED_FROM, invOption, true);

                } else {
                    addConfirmDetails(adviserFees, investmentName, value, true);
                }
            }
        });

        return adviserFees;
    }
    
    getportfolioRebateInfo() {
        const prInfo = [],
            data = _formModel.form.portfolioRebate;
        let credited = null;
        if (data.portfolioRebateOption === PortfolioRebateConstants.PortfolioRebateValues.SELECT_OPTION) {
            if (data.investmentOption !== '') {
                credited = data.investmentOptionDisplayName;
            } else {
                credited = PortfolioRebateConstants.Values.moreConservative;
            }
        } else if (data.portfolioRebateOption === PortfolioRebateConstants.PortfolioRebateValues.MORE_CONSERVATIVE) {
            credited = PortfolioRebateConstants.Values.moreConservative;
        }

        addConfirmDetails(prInfo, PortfolioRebateConstants.Labels.creditedTo, credited);

        if (_accountType == AccountTypeCodes.JOINT || _accountType == AccountTypeCodes.TRUST || _accountType == AccountTypeCodes.SMSF) {
            const linkedOption = _.result(_.find(PortfolioRebateConstants.LINK_ACCOUNT_DATA, 'id', data.linkAccountOption ), 'confirmDetailsDisplay');
            const multipleInvestorsOrTrustees = _.get(_formModel, 'form.yourDetails.investorList.length', 0) >= 2 ||
                _.get(_formModel, 'form.yourDetails.trusteeList.length', 0) >= 2;
            if (linkedOption && multipleInvestorsOrTrustees) {
                addConfirmDetails(prInfo, PortfolioRebateConstants.Labels.nominatedPortfolio, linkedOption);
            }
        }
        
        return prInfo;
    }

    getOnlineAccessInfo() {
        let onlineAccessInfo = [], investors = [], name = '';
        const data = _formModel.form.onlineAccess;

        _.forEach(data, function (model, index) {
            onlineAccessInfo = [];

            addConfirmDetails(onlineAccessInfo, OnlineAccessConstants.Labels.setupOnlineAccess, getYesNoLong(model.grantOnlineAccess));

            if (data.length > 1) {
                name = getName(index) || getCorporateName(index);
            }

            investors.push({ sectionName: name, data: onlineAccessInfo });
        });

        return investors;
    }

    getFundingYourProduct() {
        const fundingYourProduct = [];

        let internalRollover = getFypByFilter({ rollOverType: FYPConstants.RollOverTypes.INTERNAL }, getFypInternalRollover);

        if (_product.value === ProductIds.INVESTMENT) {
            let directDebit = getFypByFilter({ paymentMethod: FYPConstants.ContributionValues.DIRECT_D }, getFypPayment);
            let bPay = getFypByFilter({ paymentMethod: FYPConstants.ContributionValues.BPAY }, getFypPayment);
            let directCredit = getFypByFilter({ paymentMethod: FYPConstants.ContributionValues.DIRECT_C }, getFypPayment);
            let cheque = getFypByFilter({ paymentMethod: FYPConstants.ContributionValues.CHEQUE }, getFypPayment);

            return fundingYourProduct.concat(internalRollover, directDebit, bPay, directCredit, cheque);
        }
        else {
            let externalRollover = getFypByFilter({ rollOverType: FYPConstants.RollOverTypes.EXTERNAL }, getFypExternalRollover);
            let personalContrib = getFypByFilter({ rollOverType: FYPConstants.FundingTypes.Personal_contribution }, getFypContribution);
            let spouseContrib = getFypByFilter({ rollOverType: FYPConstants.FundingTypes.Spouse_contribution }, getFypContribution);
            let personalpayment = getFypByFilter({ rollOverType: FYPConstants.FundingTypes.Personal_injury_payment }, getFypContribution);
            let cgtContrib = getFypByFilter({ rollOverType: FYPConstants.FundingTypes.CGT_contribution }, getFypContribution);
            let downsizerContrib = getFypByFilter({ rollOverType: FYPConstants.FundingTypes.Downsizer_contribution }, getFypContribution);

            return fundingYourProduct.concat(internalRollover, externalRollover, personalContrib, spouseContrib, personalpayment, cgtContrib, downsizerContrib);
        }

    }

    getFundingYourProductTotal() {
        return Formatter.currencyFormat(_formModel.form.fundingYourProduct.totalAmount);
    }

    getFundingYourProductBankingDetails() {
        var accountDetails = _.filter(_formModel.form.fundingYourProduct.fundingSources, (data) => { return data.paymentMethod === FYPConstants.ContributionValues.DIRECT_D && data.accountNumber });

        let addConfimDetailsFyp = (details, label, value, subsection = false) => {
            details.push({ label: label, value: value, subsection: subsection });
        };

        var bankAccountDetails = [],
            bankAccountLabel = bankAccountConfirmDetailsLabel;
        if (accountDetails && accountDetails.length > 0) {
            accountDetails = accountDetails[0];
            const branchNo =  accountDetails.branchNumber && accountDetails.branchNumber.length > 0 ? Formatter.formatBranchNumber(accountDetails.branchNumber) : bankAccountLabel.incomplete;
            const accountNumber = accountDetails.accountNumber && accountDetails.accountNumber.length > 0 ? accountDetails.accountNumber : bankAccountLabel.incomplete;
            const accountHolderName = accountDetails.accountHolderName && accountDetails.accountHolderName.length > 0 ? accountDetails.accountHolderName : bankAccountLabel.incomplete;

            addConfimDetailsFyp(bankAccountDetails, FYPConstants.sectionLabels.accountHolderName, accountHolderName);
            addConfimDetailsFyp(bankAccountDetails, FYPConstants.sectionLabels.branchNumber, branchNo);
            addConfimDetailsFyp(bankAccountDetails, FYPConstants.sectionLabels.accountNumber, accountNumber, (accountDetails.bankAccountHeldOption === YesNoValues.YES));
            if (accountDetails.bankAccountHeldOption === YesNoValues.NO) {
                const bankAccountHeldOptionValue = Products.isInvestment(_product.value) ? FYPConstants.ConfirmSectionLabels.completeDirectDebitFormInvestment : FYPConstants.ConfirmSectionLabels.completeDirectDebitForm;

                addConfimDetailsFyp(bankAccountDetails, FYPConstants.ConfirmSectionLabels.accountDifferentNames, bankAccountHeldOptionValue, true);
            }

            addConfimDetailsFyp(bankAccountDetails, FYPConstants.sectionLabels.directDebitStartDate, (accountDetails.startDate) ? accountDetails.startDate : FYPConstants.ConfirmSectionLabels.directDebitNow, true);
        }

        return bankAccountDetails;
    }

    getFundingYourProductTaxClaim() {
        if (_product.value === ProductIds.PENSION) {
            var personalContribPension = _.filter(_formModel.form.fundingYourProduct.fundingSources, { claimTaxDeduction: YesNoValues.YES });
            return personalContribPension && personalContribPension.length > 0;
        }
        else if (_product.value !== ProductIds.INVESTMENT) {
            var personalContrib = _.filter(_formModel.form.fundingYourProduct.fundingSources, { rollOverType: FYPConstants.FundingTypes.Personal_contribution });
            return personalContrib && personalContrib.length > 0;
        }
        return false;
    }

    getFundingYourProductHasTermDeposit() {
        if (_formModel.form.inSpecieTransfer.setUp === YesNoValues.NO && _product.value === ProductIds.PENSION) return false;
        let internalRollOvers = _.filter(_formModel.form.fundingYourProduct.fundingSources, { rollOverType: FYPConstants.RollOverTypes.INTERNAL });
        let hasTermDeposit = _.some(internalRollOvers, function(intRollOver) {
            return _.some(intRollOver.investmentOptions, function(invOpt) {
                return invOpt.termDeposit === true && Mapper.toCurrency(invOpt.balance) > 0;
            })
        })
        return hasTermDeposit;
    }

    getAccountSettings() {
        let accountSettings = [], investors = [], name = '';
        const data = _formModel.form.accountSettings,
            bankAccountLabel = bankAccountConfirmDetailsLabel;

        _.forEach(data, function (model, index) {
            accountSettings = [];
            addConfirmDetails(accountSettings, bankAccountLabel.nameofAccountHolder, model.accountHolderName);
            addConfirmDetails(accountSettings, bankAccountLabel.branchNumber, Formatter.formatBranchNumber(model.branchNumber));
            addConfirmDetails(accountSettings, bankAccountLabel.accountNumber, model.accountNumber);

            if (data.length > 1) {
                name = getName(index);
            }

            investors.push({ sectionName: name, data: accountSettings });
        });

        return investors;
    }

    getRegularInvestmentPlan() {
        const regularInvestmentPlanInfo = [],
            data = _formModel.form.regularInvestmentPlan,
            bankAccountLabel = bankAccountConfirmDetailsLabel;

        let addConfimDetailsRipInfo = (details, label, value, indent = false, subsection = false, header = false) => {
            details.push({ label: label, value: value, indent: indent, subsection: subsection, header: header });
        };

        if (data.ripOption === YesNoValues.YES) {

            if (data.personalContribution.length > 0 || data.spouseContribution.length > 0 || data.monthlyAmountContribution.length > 0) {
                addConfimDetailsRipInfo(regularInvestmentPlanInfo, RegularInvestmentPlanConstants.Labels.investmentPlanSetupWith, '', false, false, true);
            }

            if (data.personalContribution.length > 0) {
                if (Mapper.toCurrency(data.personalContribution) > 0) {
                    let isSection = data.spouseContribution.length > 0 ? false : true;
                    addConfimDetailsRipInfo(regularInvestmentPlanInfo, RegularInvestmentPlanConstants.Labels.personalContribution, data.personalContribution, true, isSection);
                }
            }

            if (data.spouseContribution.length > 0) {
                if (Mapper.toCurrency(data.spouseContribution) > 0) {
                    addConfimDetailsRipInfo(regularInvestmentPlanInfo, RegularInvestmentPlanConstants.Labels.spouseContribution, data.spouseContribution, true, true);
                }
            }

            if (data.monthlyAmountContribution.length > 0) {
                if (Mapper.toCurrency(data.monthlyAmountContribution) > 0) {
                    addConfimDetailsRipInfo(regularInvestmentPlanInfo, RegularInvestmentPlanConstants.Labels.monthlyAmount, data.monthlyAmountContribution, true, true);
                }
            }

            addConfimDetailsRipInfo(regularInvestmentPlanInfo, RegularInvestmentPlanConstants.Labels.debitedFromFollowingAccount, '', false, false, true);
            const branchNo =  data.branchNumber && data.branchNumber.length > 0 ? Formatter.formatBranchNumber(data.branchNumber) : bankAccountLabel.incomplete;
            const isBankHeldOptionIsNo = data.bankAccountHeldOption === YesNoValues.NO;
            const bankAccount = data.bankAccount && data.bankAccount.length > 0 ? data.bankAccount : bankAccountLabel.incomplete;
            const nameOfAccountHolder = data.nameOfAccountHolder && data.nameOfAccountHolder.length > 0 ? data.nameOfAccountHolder : bankAccountLabel.incomplete;
            addConfimDetailsRipInfo(regularInvestmentPlanInfo, bankAccountLabel.nameofAccountHolder, nameOfAccountHolder, true);
            addConfimDetailsRipInfo(regularInvestmentPlanInfo, bankAccountLabel.branchNumber, branchNo, true)
            addConfimDetailsRipInfo(regularInvestmentPlanInfo, bankAccountLabel.accountNumber, bankAccount, true, !isBankHeldOptionIsNo);

            if (isBankHeldOptionIsNo) {
                if (Products.isInvestment(_product.value)) {
                    addConfimDetailsRipInfo(regularInvestmentPlanInfo, bankAccountLabel.accountInDeffNames, RegularInvestmentPlanConstants.Labels.noteBankAccountHeldInvestment, true, true);
                } else {
                    addConfimDetailsRipInfo(regularInvestmentPlanInfo, bankAccountLabel.accountInDeffNames, RegularInvestmentPlanConstants.Labels.noteBankAccountHeld, true, true);
                }
            }

            addConfimDetailsRipInfo(regularInvestmentPlanInfo, RegularInvestmentPlanConstants.Labels.investmentAllocation, '', false, false, true);

            let yearlyIncrease = data.consumerPriceIndex === YesNoValues.YES ? YesNoValues.YES_LONG : YesNoValues.NO_LONG;

            if (yearlyIncrease === YesNoValues.YES_LONG) {
                yearlyIncrease = RegularInvestmentPlanConstants.Labels.cpiYes;
            }

            if (Products.isInvestment(_product.value)) {
                addConfimDetailsRipInfo(regularInvestmentPlanInfo, RegularInvestmentPlanConstants.Labels.yearlyIncreaseInvestments, yearlyIncrease, false, false, true);
            } else {
                addConfimDetailsRipInfo(regularInvestmentPlanInfo, RegularInvestmentPlanConstants.Labels.yearlyIncrease, yearlyIncrease, false, false, true);
            }


        } else if (data.ripOption === YesNoValues.NO) {
            addConfimDetailsRipInfo(regularInvestmentPlanInfo, RegularInvestmentPlanConstants.Labels.setupRegularInvestmentPlan, YesNoValues.NO_LONG);
        }

        return regularInvestmentPlanInfo;
    }

    getRegularInvestmentPlantInvestOption() {
        const data = _formModel.form.regularInvestmentPlan,
            investmentList = [];

        _.forEach(data.investmentOptionList, (o) => {
            if (o.weight.length > 0 && Mapper.toCurrency(o.weight) > 0) {
                let row = { code: o.code, id: o.id, name: o.name, weight: o.weight };
                investmentList.push(row);
            }
        })

        return investmentList;
    }

    getSuperFirstTransferInfo() {
        let items = [];
        let data = _formModel.form.superFirstTransfer;
        if (data.nonInternalExists) {
            addConfirmDetails(items, SFTConstants.Labels.setupSuperFirstTransfer, getYesNoLong(data.isSuperTransferSetup));
        }
        return {
            items: items,
            showSection: data.nonInternalExists,
            sftInlineMessageRollover: data.sftInlineMessageRollover
        };
    }

    getInSpecieTransferInfo() {
        const data = _formModel.form.inSpecieTransfer;

        let result = { items: [], externalAccountsAllocatedAsPerQuestion: false, externalAccountsAllocatedAsPerFunds: false, setupInSpecieTransfer: false }
        if (data.setUp === YesNoValues.YES) {
            result.setupInSpecieTransfer = true;
            let accounts = data.inSpecieAccounts;
            if (accounts.length > 0) {
                result.items = accounts;
            }

            result.externalAccountsAllocatedAsPerQuestion = data.externalAccountQuestion === YesNoValues.NO;
            result.externalAccountsAllocatedAsPerFunds = data.externalAccountQuestion === YesNoValues.YES;
        } else if(data.setUp === YesNoValues.NO && data.inSpecieAccounts.length > 0) {
            addConfirmDetails(result.items, ISTConstants.Labels.setUpInSpecieTransfer, YesNoValues.NO_LONG);
        }
        return result;
    }

    getAnnuityQuoteUrl() {
        return _annuityQuoteUrl;
    }

    getInvestmentAllocation() {
        const investmentOptionsExternalOnly = _.cloneDeep(_investmentOptionsExternalOnly);
        const allocationsExternalOnly = _.cloneDeep(_assetAllocationsExternalOnly)
        const investmentOptions = _.cloneDeep(_consolidatedInvestmentOptions);
        const allocations = _.cloneDeep(_consolidatedAssetAllocations);
        const inSpecieData = _.cloneDeep(_consolidatedInSpecieOptions);
        const isPensionInSpecieTransfer = _formModel.form.inSpecieTransfer.setUp === YesNoValues.YES &&
            _product.value === ProductIds.PENSION;
        const investmentOptionsTotalAmount = _.sum(investmentOptions, invOption => { return invOption.balance; });
        const investmentOptionsExternalOnlyAmount = _.sum(investmentOptionsExternalOnly, invOption => { return invOption.balance; });
        const hasAllocations = hasAllocationsCheck(allocations, investmentOptions);
        const inSpecieNotification = InSpecieTransferHelper.getInSpecieNotification(isPensionInSpecieTransfer,
                _.get(getContent(), 'investmentAllocation.confirmDetails', {}), inSpecieData);
        const assetAllocationNotification = InSpecieTransferHelper.getAssetAllocationNotification(isPensionInSpecieTransfer,
                _.get(getContent(), 'investmentAllocation.confirmDetails', {}), inSpecieData);
        const aggregatedAllocationsForPieChart = InSpecieTransferHelper.getAggregatedAllocationForPieChart(
            investmentOptionsTotalAmount,allocations,investmentOptions);
        const  isConsolidatedTd = _.get(_formModel, 'form.investmentAllocation.consolidateContributionsForTermDeposits', YesNoValues.NO) === YesNoValues.YES &&
            _product.value === ProductIds.SUPER;
        const managedAccountName = _.get(_formModel, 'form.investmentAllocation.managedAccountName');
        const  isFirstRateCashNonAutoRebalancing = _.get(_formModel, 'form.investmentAllocation.isFirstRateCashNonAutoRebalancing', YesNoValues.NO) === YesNoValues.YES;        
        return {
            inSpecieData: inSpecieData,
            investmentOptions: investmentOptions,
            allocations: allocations,
            investmentOptionsExternalOnly: investmentOptionsExternalOnly,
            allocationsExternalOnly: allocationsExternalOnly,
            isPensionInSpecieTransfer: isPensionInSpecieTransfer,
            investmentOptionsTotalAmount: investmentOptionsTotalAmount,
            investmentOptionsExternalOnlyAmount: investmentOptionsExternalOnlyAmount,
            hasAllocations: hasAllocations,
            inSpecieNotification: inSpecieNotification,
            assetAllocationNotification: assetAllocationNotification,
            aggregatedAllocationsForPieChart: aggregatedAllocationsForPieChart,
            isConsolidatedTd: isConsolidatedTd,
            managedAccountName: managedAccountName,
            isFirstRateCashNonAutoRebalancing: isFirstRateCashNonAutoRebalancing
        };
    }

    getPensionTypeInfo() {
        return _.camelCase(_.trim(_formModel.form.pensionType.selectedBenefitItem));
    }

    getKYCStatus() {
        return _formModel.form.kycFlag;
    }

    getBeneficiaryDetails() {
        const bfDetails = [],
            constant = BeneficiaryDetailsConstant,
            data = _formModel.form.beneficiary;

        if(data.isNominateBeneficiary === YesNoValues.YES){
            if(data.type === constant.Type.REVERSIONARY){
                let title = Mapper.getGenderTitle(data.gender, data.title, _titleList, YourDetailsConstants.Values.GENDER_MALE, YourDetailsConstants.Values.GENDER_FEMALE);

                let addressline = {
                    address1: data.postalAddress1,
                    address2: data.postalAddress2,
                    cityStatePostCode: data.postalCityStatePostCode,
                    australiaState: data.postalAusState,
                    postCode: data.postalPostCode,
                    country: data.postalCountry
                };

                let address = (data.definePostalAddressLine === '')
                    ? data.postal
                    : Formatter.formatPostalAddress(addressline, _countryList);
                addConfirmDetails(bfDetails, constant.Labels.BENEFICIARY_TYPE, constant.BeneficiaryTypeData[0].name);
                addConfirmDetails(bfDetails, YourDetailsConstants.Labels.gender, _.get(_.find(YourDetailsConstants.GenderRadioData, { 'id': data.gender }), 'name', ''));
                addConfirmDetails(bfDetails, YourDetailsConstants.Labels.name, Formatter.formatFullname(title, data.givenName, data.lastName));
                addConfirmDetails(bfDetails, YourDetailsConstants.Labels.dateOfBirth, data.dateOfBirth);
                addConfirmDetails(bfDetails, YourDetailsConstants.Labels.postalAddress, address);
                addConfirmDetails(bfDetails, YourDetailsConstants.Labels.mobileNumber, Formatter.formatPhone(data.mobileNumber));
                addConfirmDetails(bfDetails, YourDetailsConstants.Labels.homeNumber, Formatter.formatPhone(data.homeNumber));
                addConfirmDetails(bfDetails, YourDetailsConstants.Labels.workNumber, Formatter.formatPhone(data.workNumber));
                addConfirmDetails(bfDetails, YourDetailsConstants.Labels.emailAddress, data.emailAddress);
                addConfirmDetails(bfDetails, constant.Labels.RELATIONSHIP, _.get(_.find(constant.RelationshipData, { 'id': data.relationship }), 'name', ''));

            } else if (data.type === constant.Type.NON_LAPSING){
                addConfirmDetails(bfDetails, constant.Labels.BENEFICIARY_TYPE, constant.BeneficiaryTypeData[1].name);
            }
        }
        else {
            addConfirmDetails(bfDetails, constant.Labels.BENEFICIARY_TYPE, constant.noNominationText);
        }

        return bfDetails;
    }

    getSpecialRequestsInfo() {
        const data = _formModel.form.specialRequests;

        return (data.isWithSpecialRequests === YesNoValues.YES) ? data.specialRequestsDetails : '';
    }

    getAdviserAuthorityInfo() {

        const advsierAuthorityDetails = [];
        const data = _formModel.form.adviserAuthority;
        const userContext = window.NOA.userContext;
                
        if (Products.isAnnuity(_productId)) {
            _showOnlineAccessSection = true;  
        }
        else if(userContext.isAdviser) {
            _showOnlineAccessSection = !(data.isAdviserAuthorised === YesNoValues.YES);  
        }
        else if (userContext.isInvestor && userContext.isExisting){        
            _showOnlineAccessSection = false;  
        }
        else{
            _showOnlineAccessSection = true; 
        }

        addConfirmDetails(advsierAuthorityDetails, 'Set up Adviser Transaction Authority', getYesNoLong(data.isAdviserAuthorised));
    
        return advsierAuthorityDetails;
    }

    getAdviserAttestationInfo() {
        const advsierAttestationDetails = [];
        const data = _formModel.form.adviserAttestation;

        addConfirmDetails(advsierAttestationDetails, 'Adviser attestation provided', getYesNoLong(data.attestation));
    
        return advsierAttestationDetails;
    }

    getPensionPayment() {
        const pensPaymentDetails = [],
            constant = PensionPaymentConstants,
            data = _formModel.form.pensionPayment,
            bankAccountLabel = bankAccountConfirmDetailsLabel,
            startDate = data.accountStartDateOption === constant.AccountStart.ASAP ? 'As soon as possible' : data.accountStartDate,
            frequency = getPensionPaymentFrequency(data, constant),
            deferPayments = data.deferPayments === YesNoValues.YES ? YesNoValues.YES_LONG : YesNoValues.NO_LONG,
            isGrossNotSpecific = data.paymentLevelsOption !== constant.PaymentLevels.SPECIFIC,
            gross = isGrossNotSpecific ? data.paymentLevelsOption.charAt(0).toUpperCase() + data.paymentLevelsOption.slice(1) : Formatter.currencyFormat(data.paymentGrossAmount, true),
            branchNo = data.branchNumber && data.branchNumber.length > 0 ? Formatter.formatBranchNumber(data.branchNumber) : bankAccountLabel.incomplete,
            accountHolderName = data.accountHolderName && data.accountHolderName.length > 0 ? data.accountHolderName : bankAccountLabel.incomplete,
            accountNumber = data.accountNumber && data.accountNumber.length > 0 ? data.accountNumber : bankAccountLabel.incomplete,
            isFrequencySubsection = !data.deferPaymentsText,
            isWithinFYearSubsection = !data.deferPaymentsWithinFYearText,
            isFirstPaymentDuringCoolingOff = data.firstPaymentDuringCoolingOff === YesNoValues.YES ? YesNoValues.YES_LONG : YesNoValues.NO_LONG, 
            isFirstPaymentProrata = data.proRataFirstPayment === YesNoValues.YES ? YesNoValues.YES_LONG : YesNoValues.NO_LONG, 
            addConfirmDetailsPensPayment = (details, label, value, subsection = false) => {
                details.push({ label: label, value: value, subsection: subsection });
            };
        let drawDownTypeOption;

        addConfirmDetailsPensPayment(pensPaymentDetails, constant.Labels.ACC_START_OPT_LABEL, startDate, true);
        addConfirmDetailsPensPayment(pensPaymentDetails, constant.Labels.PAYMENT_CREDITED_ACCT_LABEL, '');
        addConfirmDetailsPensPayment(pensPaymentDetails, constant.Labels.NAME_ACC_HOLDER_LABEL, accountHolderName);
        addConfirmDetailsPensPayment(pensPaymentDetails, constant.Labels.BRANCH_NUMBER_LABEL, branchNo);
        addConfirmDetailsPensPayment(pensPaymentDetails, constant.Labels.ACC_NUMBER_LABEL, accountNumber, true);
        addConfirmDetailsPensPayment(pensPaymentDetails, constant.Labels.PAYMENT_FREQUENCY_LABEL, frequency, isFrequencySubsection);
        if (!isFrequencySubsection) {
            addConfirmDetailsPensPayment(pensPaymentDetails, constant.Labels.YEARLY_FREQUENCY_TEXT_LABEL, data.deferPaymentsText, true);
        }
        addConfirmDetailsPensPayment(pensPaymentDetails, constant.Labels.DEFER_PAYMENTS_LABEL, deferPayments, isWithinFYearSubsection);        
        if (!isWithinFYearSubsection) {
            addConfirmDetailsPensPayment(pensPaymentDetails, constant.Labels.YEARLY_FREQUENCY_TEXT_LABEL, data.deferPaymentsWithinFYearText, true);
        }

        addConfirmDetailsPensPayment(pensPaymentDetails, constant.Labels.FIRST_PAYMENT_COOLING_OFF_LABEL, isFirstPaymentDuringCoolingOff, true);
        addConfirmDetailsPensPayment(pensPaymentDetails, constant.Labels.PAYMENT_GROSS_AMOUNT_LABEL, gross, isGrossNotSpecific);

        if (!isGrossNotSpecific) {
            if (data.annualPercentage) {
                addConfirmDetailsPensPayment(pensPaymentDetails,
                    constant.Labels.ANNUAL_PERCENTAGE_LABEL,
                    Formatter.currencyFormatWithoutRounding(data.annualPercentage) + '%',
                    true);
            } else {
                let annaulIncreaseIdx = _.findIndex(constant.AnnualIncreaseData, 'id', data.annualIncreaseOption);
                if (annaulIncreaseIdx > -1) {
                    addConfirmDetailsPensPayment(pensPaymentDetails,
                        constant.Labels.ANNUAL_PERCENTAGE_LABEL,
                        constant.AnnualIncreaseData[annaulIncreaseIdx].name,
                        true);
                }
            }
            addConfirmDetailsPensPayment(pensPaymentDetails, constant.Labels.PRO_RATA_FIRST_PAYMENT_LABEL, isFirstPaymentProrata, true);
        }

        if (data.drawDownTypeOption) {
            drawDownTypeOption = (data.drawDownTypeOption === constant.DrawDownTypeOption.ORDER) ? 'By order' : 'By percentage';
            addConfirmDetailsPensPayment(pensPaymentDetails, constant.Labels.DRAW_DOWN_OPTION_LABEL, drawDownTypeOption);
        }else if (data.drawDownOption === constant.DrawDownOption.CONSERVATIVE) {
            let consvIdx = _.findIndex(constant.DrawDownOptionData, 'id', data.drawDownOption);
            if (consvIdx > -1) {
                addConfirmDetailsPensPayment(pensPaymentDetails,
                    constant.Labels.DRAW_DOWN_OPTION_LABEL,
                    constant.DrawDownOptionData[consvIdx].name);
            }
        }

        return pensPaymentDetails;
    }

    getPensionPaymentInvestOption() {
        const data = _formModel.form.pensionPayment,
            constant = PensionPaymentConstants,
            investmentList = [];

        _.forEach(data.investmentOptionList, (o) => {
            let row = data.drawDownTypeOption === constant.DrawDownTypeOption.ORDER ? { code: o.code, id: o.id, name: o.name, order: o.order } : { code: o.code, id: o.id, name: o.name, weight: o.weight };
            if ((data.drawDownTypeOption === constant.DrawDownTypeOption.PERCENTAGE && row.weight.length > 0 && Mapper.toCurrency(row.weight) > 0) || data.drawDownTypeOption === constant.DrawDownTypeOption.ORDER) {
                investmentList.push(row);
            }
        });

        return investmentList;
    }

    getShowHideMore() {
        return _showMoreMenu;
    }

    getAccountType() {
        let accountTypes = [];

        let accountType = _.find(_accountTypeList, {id: _accountType});
        addConfirmDetails(accountTypes, AccountTypeConstants.labels.accountType, accountType ? accountType.name : '');

        return accountTypes;
    }

    getApplication() {
        return _formModel;
    }
    
    getAccountNumber() {
        return _accountNumber;
    }

    getHasSubmitFailed() {
        return _hasSubmitFailed;
    }

    getAccountTypeCode() {
        return _accountType;
    }

    getShowDownloadMenu() {
        return _showDownloadMenu;
    }
    getFormsToDownload() {
        return _formsToDownload;
    }
    getEnableDownloadButton() {
        let checked = _.where(_formsToDownload, {'checked':true});
        return checked && checked.length > 0;
    }
    getDownloadInProgress() {
        return _downloadInProgress;
    }
    getSelectedForms() {
        return _selectedForms;
    }
    getReadyForDownload() {
        return _readyForDownload === true && _downloadInProgress === true;
    }
    getDownloadedForms() {
        return _downloadedForms;
    }
    getIsFormsDownloaded() {
        return _formDownloaded;
    }
    getDownloadFormsFailed() {
        if (_downloadInProgress) {
            return false;
        }
        return _downloadFormsFailed;
    }
    getWorkItem() {
        return _workItem;
    }
    canContinue() {
        return !Products.isAnnuity(_productId) || (!_isEmulation && _canSubmitApplication);
    }
    isInSpecieScenarioValid() {
        return _isInSpecieScenarioValid;
    }
    getIsInSpecieScenarioNotificationClosed() {
        return _isInSpecieScenarioNotificationClosed;
    }
    showOnlineAccessSection(){
       
        return _showOnlineAccessSection ;
    }
}

// Initialize the singleton to register with the
// dispatcher and export for React components
const ConfirmDetailsStore = new ConfirmDetailsStoreClass();

// Register each of the actions with the dispatcher
// by changing the store's data and emitting a change
AppDispatcher.register((action) => {

    switch (action.actionType) {
        case ActionTypes.NEW_APPLICATION_INITIALISED:
            _productId = action.productId;
            break;
        case ActionTypes.APPLICATION_SAVE_REQUEST:
        case ActionTypes.APPLICATION_SAVE_STARTING:
            updateYourDetailsForSave();
            break;
        case ActionTypes.AGREE_IDVERIFICATION_FORM:
            agreeIdVerificationForm();
            break;
        case ActionTypes.REVIEW_APPLICATION:
            setReviewData(action.formModel, action.product, action.sectionVisibility);
            calculateInvAllocations();
            break;
        case ActionTypes.UPDATE_VERIFICATOIN_DOCUMENT:
            updateFormModelIdVerification(action.data);
            break;
        case ActionTypes.SET_WORKITEM:
            setWorkItem();
            break;
        case ActionTypes.UPDATE_WORKITEM:
            updateFormModelWorkItem(action.workItem);
            break;
        case ActionTypes.LOAD_TITLE_LIST:
            _titleList = action.titles;
            break;

        case ActionTypes.LOAD_COUNTRY_LIST:
            _countryList = action.countryList;
            break;
        case ActionTypes.RECEIVE_ANNUITY_QUOTE_URL:
            _annuityQuoteUrl = action.data;
            break;
        case ActionTypes.SHOW_MORE_MENU:
            _showMoreMenu = action.showMoreMenu;
            break;
        case ActionTypes.LOAD_TFN_EXEMPTION_LIST:
            _tfnExemptionList = action.tfnExemptionList;
            break;
        case AccountTypeActionTypes.LOAD_ACCOUNT_TYPE_LIST:
            _accountTypeList = action.accountTypes;
            break;
        case ActionTypes.APPLICATION_SAVE_SUCCESS:
            setApplicationId(action.applicationId, action.wipId);
            break;
        case ActionTypes.APPLICATION_SUBMIT_SUCCESS:
            setAccountNumber(action.data.accountNumber);
            break;
        case ActionTypes.APPLICATION_SUBMIT_FAILED:
            _hasSubmitFailed = true;
            _formModel.submitDate = '';
            break;
        case ActionTypes.SHOW_DOWNLOAD_MENU:
            toggleDownloadMenu(action.showDownloadMenu);
            break;
        case ActionTypes.UPDATE_FORMS_TO_DOWNLOAD:
            updateFormsToDownload(action.index, action.checked);
            break;
        case ActionTypes.PREPARE_FORMS_TO_DOWNLOAD:
            getSelectedForms();
            break;
        case ActionTypes.APPLICATION_DOWNLOAD_REQUEST:
            _readyForDownload = true;
            break;
        case ActionTypes.START_DOWNLOADING_FORMS:
            _readyForDownload = false;
            break;
        case ActionTypes.DOWNLOAD_FORMS_SUCCESS:
            receiveDownloadedApplicationForm(action.data);
            break;
        case ActionTypes.CLEAR_DOWNLOADED_FORMS:
            _downloadedForms = undefined;
            _formDownloaded = true;
            _selectedForms = [];
            break;
        case ActionTypes.DOWNLOAD_FORMS_FAILED:
            _downloadInProgress = false;
            _formDownloaded = true;
            _downloadFormsFailed = true;
            break;
        case ActionTypes.CLOSE_INSPECIE_MANUAL_SCENARIO_NOTIFICATION:
            _isInSpecieScenarioNotificationClosed = true;
            break;
        case ActionTypes.UPDATE_ADVISER_TRANSACT_AUTHORITY:
            updateAdviserAuthorityModel(action.fieldId, action.value);
            break;
        case ActionTypes.LOAD_SOURCEOFFUND_LIST:
            _sourceOFFundList = action.sourceOfFundList;
            break;
        case ActionTypes.LOAD_SOURCEOFWEALTH_LIST:
            _sourceOFWealthList = action.sourceOfWealthList;
            break
        default:
            return true;
    }

    ConfirmDetailsStore.emitChange();
    return true;
});

export default ConfirmDetailsStore;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./stores/ConfirmDetailsStore.js